import axios from "axios";

/**
 * Fetches country information based on user's IP address using ipinfo.io API
 * @returns {Promise<{success: boolean, country: string|null, country_code: string|null, error: string|null}>}
 */
export const getCountryFromIP = async () => {
  try {
    // Check localStorage cache first (valid for 24 hours)
    const cached = localStorage.getItem("user_country_data");
    if (cached) {
      let parsed;
      try {
        parsed = JSON.parse(cached);
      } catch (e) {
        // Corrupt or invalid cache entry — treat as a cache miss
        localStorage.removeItem("user_country_data");
        parsed = null;
      }
      if (parsed) {
        const { country, country_code, timestamp } = parsed;
        const isExpired = Date.now() - timestamp > 24 * 60 * 60 * 1000;
        if (!isExpired && country) {
          return { success: true, country, country_code };
        }
        localStorage.removeItem("user_country_data");
      }
    }

    const token = process.env.REACT_APP_IP_LOCATION_API;
    if (!token) {
      return {
        success: false,
        country: null,
        country_code: null,
        error: "API token not configured",
      };
    }
    const response = await axios.get("https://api.ipinfo.io/lite/me", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 10000,
    });
    const country = response.data?.country || null;
    const country_code = response.data?.country_code || null;

    if (country) {
      // Cache the result
      localStorage.setItem(
        "user_country_data",
        JSON.stringify({ country, country_code, timestamp: Date.now() }),
      );
      return { success: true, country, country_code };
    }

    return { success: false, country: null, country_code: null, error: "Country not found" };
  } catch (error) {
    return {
      success: false,
      country: null,
      country_code: null,
      error: error?.response?.data?.message || error?.message || "An unexpected error occurred",
    };
  }
};
